import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  FieldGroup,
  ErrorMessage,
} from 'anf-core-react';
import CardNumber from './CardNumber';
import ExpiryField from './ExpiryField';
import CVVField from './CVVField';
import CheckoutPageContext from '../../../context/CheckoutPageContext';
import { useIsM } from '../../../hooks/useBreakPoint';
import { scrollToElementById } from '../../../tools/utils';

export default function CreditCard({
  hasValidationError,
}) {
  const isMobileView = useIsM();
  const { checkoutPageState } = useContext(CheckoutPageContext);
  const { paymentConfig: { creditCard: creditCardConfig } = {} } = checkoutPageState || {};
  const selectedPaymentType = checkoutPageState?.selectedPaymentType || '';
  const paymentStatusCode = checkoutPageState?.orderSubmit?.statusMessages?.[0]?.code;
  const isCardDeclinedOnPayment = selectedPaymentType === 'credit card' && paymentStatusCode === 'DECLINED';

  useEffect(() => {
    if (isCardDeclinedOnPayment) {
      scrollToElementById({ id: 'card-input-0', offset: 125, isMobileView });
    }
  }, [isCardDeclinedOnPayment, isMobileView]);

  return (
    <div className="credit-card-fields">
      <FieldGroup legend="Credit Card Fields" isInvalid={hasValidationError?.card || isCardDeclinedOnPayment}>
        <CardNumber hasValidationError={hasValidationError?.cardNumber} />
        <ExpiryField hasValidationError={hasValidationError?.cardExpiry} />
        <CVVField hasValidationError={hasValidationError?.cardCvv} />
        {(hasValidationError?.card || isCardDeclinedOnPayment) && (
          <ErrorMessage id="cc-error-message">
            {creditCardConfig?.unableToProcessCardErrorMessage?.value || ''}
          </ErrorMessage>
        )}
      </FieldGroup>
    </div>
  );
}

CreditCard.defaultProps = {
  hasValidationError: {},
};

CreditCard.propTypes = {
  hasValidationError: PropTypes.shape({
    card: PropTypes.bool,
    cardNumber: PropTypes.bool,
    cardExpiry: PropTypes.bool,
    cardCvv: PropTypes.bool,
  }),
};
